// This script toggles the visibility of the mobile search icon in the header
// when the menu drawer is opened or closed.
// It assumes the search icon in the header has a class like '.header__icon--search' or similar.
// Adjust the selector if your theme uses a different class or id.

(function() {
    // Helper: returns true if on mobile
    function isMobile() {
      return window.innerWidth <= 990;
    }
  
    // Get the header search icon (not the one inside the drawer)
    function getHeaderSearchIcon() {
      // Try common selectors; adjust as needed for your theme
      return document.querySelector('.header__icon--search');
    }
  
    // Hide/show the header search icon
    function setHeaderSearchIconVisible(visible) {
      var icon = getHeaderSearchIcon();
      if (!icon) return;
      icon.style.display = visible ? '' : 'none';
    }
  
    // Listen for menu drawer open/close
    document.addEventListener('DOMContentLoaded', function() {
      var headerDrawer = document.querySelector('header-drawer');
      if (!headerDrawer) return;
  
      // Listen for attribute changes on the <details> element
      var details = headerDrawer.querySelector('details');
      if (!details) return;
  
      function updateSearchIcon() {
        if (!isMobile()) {
          setHeaderSearchIconVisible(true);
          return;
        }
        if (details.hasAttribute('open')) {
          setHeaderSearchIconVisible(false);
        } else {
          setHeaderSearchIconVisible(true);
        }
      }
  
      // Observe changes to the 'open' attribute
      var observer = new MutationObserver(updateSearchIcon);
      observer.observe(details, { attributes: true, attributeFilter: ['open'] });
  
      // Also update on resize (in case of orientation change)
      window.addEventListener('resize', updateSearchIcon);
  
      // Initial state
      updateSearchIcon();
    });
  })();
  